import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import createCssVarRevertPlugin from 'css-vars-revert';
import { jsx as _jsx } from "react/jsx-runtime";
var lagacyStyleAwareCache = createCache({
  key: 'legacy-css',
  stylisPlugins: [createCssVarRevertPlugin({
    applyWhen: () => !window.CSS || !CSS.supports('color', 'var(--fake-var)')
  })]
});
export var LegacyStyleProvider = _ref => {
  var {
    children
  } = _ref;
  return /*#__PURE__*/_jsx(CacheProvider, {
    value: lagacyStyleAwareCache,
    children: children
  });
};
//# sourceMappingURL=LegacyStyleProvider.js.map